import { forwardRef, type InputHTMLAttributes } from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@/components/ui/cn";

const vInputVariants = cva(
  "flex w-full rounded-lg border bg-card px-3 py-2 text-sm shadow-xs transition-colors " +
    "placeholder:text-muted-foreground " +
    "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-1 " +
    "disabled:cursor-not-allowed disabled:opacity-50",
  {
    variants: {
      invalid: {
        true: "border-error-500",
        false: "border-input",
      },
      inputSize: {
        sm: "h-8 text-sm",
        md: "h-10 text-sm",
        lg: "h-11 text-base",
      },
    },
    defaultVariants: {
      invalid: false,
      inputSize: "md",
    },
  },
);

type VInputProps = Omit<InputHTMLAttributes<HTMLInputElement>, "size"> &
  VariantProps<typeof vInputVariants>;

export const VInput = forwardRef<HTMLInputElement, VInputProps>(
  ({ className, invalid, inputSize, type = "text", ...props }, ref) => (
    <input
      ref={ref}
      type={type}
      className={cn(vInputVariants({ invalid, inputSize }), className)}
      {...props}
    />
  ),
);
VInput.displayName = "VInput";

export type { VInputProps };
